import React from "react";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { TicketType } from "../../../../types";
import addIcon from "assets/svgs/ic_plus_primary.svg";
import { DropdownIcon } from "app/components/Icons";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../Tickets/redux/slice";
import { selectTicketTypes } from "app/redux/selector";

interface AddTaskButtonProps {
  selectedType: string;
  groupId: string;
  dropzoneRef: React.RefObject<HTMLDivElement>;
  showAddTaskIcon: boolean;
}

const AddTaskButton: React.FC<AddTaskButtonProps> = ({
  selectedType,
  groupId,
  dropzoneRef,
  showAddTaskIcon,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const data = useSelector(selectTicketTypes);
  const handleTicketType = (value: string) => {
    dispatch(actions.setTicketFormValue({ name: "groupId", value: groupId }));
    dispatch(actions.setTicketFormValue({ name: "type", value: value }));
    dropzoneRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleTicketTask = () => {
    dispatch(actions.setTicketFormValue({ name: "groupId", value: groupId }));
    dispatch(actions.setTicketFormValue({ name: "type", value: data[0]?._id }));
    dropzoneRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <button
        onClick={() => {}}
        className={`${showAddTaskIcon?" hidden ":""} flex flex-row w-fit items-center gap-[4px] mt-[5px] mb-[15px] group `}
      >
        <div className="flex justify-center items-center size-[20px]">
          <img src={addIcon} alt="add" className="size-[20px]" />
        </div>
        <div className="flex flex-row items-center group-hover:bg-white group-hover:border group-hover:border-[#E9ECF2] rounded-[4px]">
          <button
            className="hover:bg-[#ECEEF2]  h-[20px] px-[6px] py-auto pb-2 text-sm leading-[21px] font-medium text-primary"
            onClick={(e) => {
              e.stopPropagation();
              handleTicketTask();
            }}
          >
            Add task
          </button>
          <CommonTicketTypeSelection
            setOpen={() => {
              setOpen(!open);
            }}
            trigger={
              <button
                className={` group-hover:visible hover:bg-[#ECEEF2] border-l-[1px] border-[#E9ECF2] justify-center items-center size-[20px] ${
                  open ? "rotate-180" : "rotate-270"
                }
                      `}
              >
                <DropdownIcon size={20} />
              </button>
            }
            value={selectedType}
            setValue={(data) => {
              handleTicketType(data?._id);
            }}
            isHeader="TICKET TYPES"
            className="!w-[237px]"
            isHeaderClassName="!text-[#79808A] !text-sm !font-semibold "
            showDefault
          />
        </div>
      </button>
    </>
  );
};

export default AddTaskButton;
